import { BrowserOptions } from "./types/options";
import { initAndBind } from "@jupiter/core";
import { BrowserClient } from "./client";
import { GlobalHandlers } from "./integrations";
import { Logger } from "@jupiter/utils";

export const defaultIntegrations = [new GlobalHandlers()];

const DEFAULT_ENDPOINT =
  "https://wifi.12306.cn/operatemonit/wifiapps/applog/logApi/send";

export function init(options: BrowserOptions) {
  if (options.debug === true) {
    Logger.enable();
  }

  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }

  if (options.endpoint === undefined) {
    options.endpoint = DEFAULT_ENDPOINT;
  }

  initAndBind(BrowserClient, options);
}
